
import React, { useState, useCallback, useEffect } from 'react';
import { Form, Tabs, Tab, Row, Col, Button, Spinner } from 'react-bootstrap';
import { downloadFile, formatDate, getOverAllRating,getRandomNumber } from '../../../utils/utils';
import { DocumentIcon, CalernderIcon, OverviewIcon, DocsIcon, VideoIcon, ReviewIcon, SummaryIcon, CertificateIcon, RemarksIcon } from '../../../utils/FontIcon';
import Rating from '../../shared/Rating';
import { Input, PopupModel } from '../../shared';
import { useLogin } from '../../../context/LoginContext';
import { subscribe, unsubscribe } from '../../../utils/pubsubWrapper';
import { useLesson } from '../../../context/LessonContext';
import apiClient from '../../../api/apiClient';
import { GETCOURSELIST, GETCERTIFICATES } from '../../../utils/ApiEndPoint';
import { useCourse } from '../../../context/CourseContext';
import LessonsList from  './LessonsList';



function Coursedetail({ lesson }) {
    const { user } = useLogin();
    const { courseDetail, lessons } = useLesson();
    const { getCourseProgerssStatusById, userCourse } = useCourse();
    const [remarks, setRemarks] = useState('');
    const [isPublic, setIsPublic] = useState(false);
    const [remarksError, setRemarksError] = useState('');
    const [removeLessonList, setRemoveLessonList] = useState([]);
    const [isCourseCompleted, setIsCourseCompleted] = useState(false);
    const [certificates, setCertificates] = useState([]);
    const [waitForResponse, setWaitForResponse] = useState(false);
    const [popupData, setPopupData] = useState({
        show: false,
        title: '',
        type: '',
        selectedItem: [],
    });
    useEffect(() => {
        const pubsubToken = subscribe('UPDATE_REMOVE_LESSON', (data) => {
            if (!(data?.checked)) {
                setRemoveLessonList(prev => [...prev, data?.lesson?.refDetails?._id]);
            } else {
                setRemoveLessonList(prev => prev.filter(item => item !== data?.lesson?.refDetails?._id));
            }
        });
        return () => unsubscribe(pubsubToken);
    }, []);
    useEffect(() => {
        if (userCourse.length && courseDetail?._id) {
            const isCompleted = getCourseProgerssStatusById(courseDetail?._id);
            if (isCompleted) {
                fetchCertificates();
            }
            setIsCourseCompleted(isCompleted);
        } else {
            setIsCourseCompleted(false);
        }
    }, [userCourse, courseDetail?._id]);
    const handleChange = useCallback((e) => {
        const { name, value } = e.target;
        setRemarks(value);
        setRemarksError('');
    }, []);
    const handelUpdateStatus = async (status) => {
        if (remarks == '') {
            setRemarksError('This field is required');
        } else {
            updateStatus(status);
        }
    }
    const checkValidLessonType = (allLesson, type) => {
        return allLesson.some(lesson => lesson?.type && lesson.type.toLowerCase() === type.toLowerCase());
    };
    const updateStatus = (status) => {
        setWaitForResponse(true);
        const { _id, title, description, refDoc } = courseDetail;
        let tempPopup = {
            show: true,
            title: 'Error',
            type: 'error',
            selectedItem: { msg: '' },
        }
        const tempLessons = [...lessons, ...refDoc];
        const allLesson = tempLessons.filter(lesson => {
            return !removeLessonList.includes(lesson?.refDetails?._id);
        });
        const hasVideo = checkValidLessonType(allLesson, 'video');
        const hasQuize = checkValidLessonType(allLesson, 'quiz');
        if (!hasVideo && !hasQuize) {
            tempPopup.selectedItem.msg = `❌ At least one video and one quiz is required to update the course status.`;
            setPopupData(tempPopup);
            return;
        } else if (hasVideo && !hasQuize) {
            tempPopup.selectedItem.msg = `❌ At least one quiz is required to update the course status.`;
            setPopupData(tempPopup);
            return;
        } else if (!hasVideo && hasQuize) {
            tempPopup.selectedItem.msg = `❌ At least one video is required to update the course status.`;
            setPopupData(tempPopup);
            return;
        }
        const data = {
            "title": title,
            "description": description,
            "modules": JSON.stringify([{ 'title': title, 'lessons': JSON.stringify(allLesson) }]),
            "updatedBy": "64e77b2c74e913f546785f00",
            "status": status,
            "remarks": remarks,
            'accessMode': isPublic ? 'public' : "Mandatory"
        }

        apiClient.put(`${GETCOURSELIST}/${_id}`, data)
            .then((response) => {
                if (response.status === 200) {
                    tempPopup.title = 'Success';
                    tempPopup.type = 'success',
                        tempPopup.selectedItem.msg = `✅ Status of ${title} is updated successfully`

                } else {
                    tempPopup.selectedItem.msg = `❌ Failed to update status of ${title}`;
                }

            }).catch((error) => {
                tempPopup.selectedItem.msg = `❌ Failed to update status of ${title}`;
            }).finally(() => {
                setPopupData(tempPopup);
            })
    }
    const hidePupop = () => {
        if (popupData.type === 'success') {
            window.location.reload();
        } else {
            setPopupData({
                show: false,
                title: '',
                type: '',
                selectedItem: { msg: '' },
            })
        }
        setWaitForResponse(false);

    }
    const fetchCertificates = async () => {
        try {
            apiClient.get(`${GETCERTIFICATES}/${user.userId}?page=1&limit=10&status=issued`)
                .then((response) => {
                    if (response.status === 200) {
                        setCertificates(response.data.items);
                    }
                }).catch((error) => {
                });
        } catch (error) {
            console.error("Error fetching certificates:", error);
        }
    }
    const getCertificateUrl = (courseId) => {
        const certificate = certificates.find(cert => cert.courseId === courseId);
        return certificate ? certificate?.certificateUrl : null;
    }
    return (
        <>
            <Tabs
                defaultActiveKey="overview"
                id="justify-tab-example"
                className="mb-3 courses-tabcontainer"
                justify
            >
                <Tab eventKey="videolist" className='show-videotab' title=
                    {<><VideoIcon style={{ width: '20%', display: 'inline-block' }} title="Course Resource" /> Content</>}>
                         <LessonsList/>
                </Tab>
                <Tab eventKey="overview" title=
                    {<><OverviewIcon style={{ width: '20%', display: 'inline-block', position: 'relative', top: '-2px' }} title="Overview" /> Overview</>}>
                    <Row>
                        <Col md={12}>
                            <Row>
                                <Col sm={9} xs={8} >
                                    <small>
                                        <span className='fw-600 text-muted'>Course Created on:- </span><br />
                                        <span className='text-muted'><CalernderIcon style={{ marginRight: '7px' }} />{formatDate(lesson?.createdAt, false)}</span>
                                    </small>
                                </Col>
                                {user?.selectedRole === 'viewer' &&
                                    (<Col sm={3} xs={4} className="text-end">
                                        <div><span style={{ fontSize: '0.9rem', color: '#ff6600', fontWeight: 700, padding: '5px' }}>{courseDetail?.courseRatingSummary?.averageRating || 0}</span><small>({courseDetail?.courseRatingSummary?.totalRatings || 0} rating)</small></div>
                                        <div>
                                            {getOverAllRating(courseDetail?.courseRatingSummary?.averageRating || 0)}
                                        </div>
                                    </Col>)
                                }
                            </Row>
                        </Col>
                        <Col xs={12} className='p-2 '>
                            <h5 className='fw-700'>{lesson?.title}</h5>
                            <small>
                                <span className='fw-600'>Description: </span>
                                <span>{lesson?.description || 'No description available.'}</span>
                            </small>
                        </Col>
                        <Col xs={12} className='p-2 text-start course-overview-wrapper'>
                            <h4 style={{ color: '#2125298f' }}><span><SummaryIcon title="Course Summary" /> Course Summary</span></h4>
                            <span style={{ display: 'block', paddingLeft: '.25rem', textAlign: 'justify' }}>{courseDetail?.description || 'No description available.'}</span>
                        </Col>
                        {user.selectedRole.includes('approver') ?
                            courseDetail?.status === "draft" ?
                                <Col xs={12} className='p-2 text-start course-overview-wrapper'>
                                    <h4 style={{ color: '#2125298f' }}><span><RemarksIcon /> Add Remarks</span></h4>
                                    <Form>
                                        <Input
                                            label="Remarks"
                                            isMandetory={true}
                                            name="remarks"
                                            value={remarks || ''}
                                            onChange={handleChange}
                                            placeholder="Add your remarks"
                                            isInvalid={!!remarksError}
                                            feedback={remarksError}
                                            as="textarea"
                                            rows={4}
                                            inlineFeedback={true}
                                            maxLength={500}
                                        />
                                        <span style={{ display: 'block', marginBottom: '8px' }}><strong>Mark as :-</strong></span>
                                        <div className="mb-3">
                                            <Form.Check
                                                inline
                                                label="Public"
                                                name="marked"
                                                type="radio"
                                                id="markPublic"
                                                value="public"
                                                checked={isPublic}
                                                onChange={(e) => setIsPublic(true)}
                                            />
                                            <Form.Check
                                                inline
                                                label="Mandatory"
                                                name="marked"
                                                type="radio"
                                                value="mandatory"
                                                checked={!isPublic}
                                                onChange={(e) => setIsPublic(false)}
                                            />
                                        </div>
                                        {waitForResponse ? <>
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                className="me-2"
                                                variant="primary"
                                            />
                                            Wait...</> : <>
                                            <Button variant="success" className='me-3' onClick={() => handelUpdateStatus('published')} title='Approve'>Approve</Button>
                                            <Button variant="danger" onClick={() => handelUpdateStatus('rejected')} title='Reject'>Reject</Button>
                                        </>
                                        }
                                    </Form>

                                </Col>
                                :
                                <Col xs={12} className='p-2 text-start course-overview-wrapper'>
                                    <h4 style={{ color: '#2125298f' }}><span><RemarksIcon /> Remarks</span></h4>
                                    <span style={{ display: 'block', paddingLeft: '.25rem', textAlign: 'justify' }}>{courseDetail?.remarks || 'No remarks'}</span>
                                </Col>
                            : user.selectedRole.includes('creater') ?
                                <Col xs={12} className='p-2 text-start course-overview-wrapper'>
                                    <h4 style={{ color: '#2125298f' }}><span>Remarks</span></h4>
                                    <span style={{ display: 'block', paddingLeft: '.25rem', textAlign: 'justify' }}>{courseDetail?.remarks || 'No remarks'}</span>
                                </Col>
                                :
                                <Col xs={12} className='p-2 text-start course-overview-wrapper'>
                                    <h4 style={{ color: '#2125298f' }}><span><CertificateIcon title="Certificate Info" /> Certificate info</span></h4>
                                    {isCourseCompleted ? <Col lg={4} onClick={() => {
                                        const url = getCertificateUrl(courseDetail?._id);
                                        url && window.open(url, '_blank')
                                    }} style={{ cursor: 'pointer' }}>
                                        <img src={'/lms/img/certificate.jpeg'} alt='Certificate Info' width='100px' />
                                    </Col> : <span style={{ display: 'block', paddingLeft: '.25rem', textAlign: 'justify' }}>
                                        Certificate will be available after course completion.
                                    </span>}
                                </Col>}
                    </Row>

                </Tab>
                <Tab eventKey="dodument" title=
                    {<><DocsIcon style={{ width: '20%', display: 'inline-block' }} title="Course Resource" /> Course Resource</>}>
                    <Row>
                        {courseDetail?.refDoc?.length ? (
                            <Col xs={12} className='p-2 '>
                                <h5 className='fw-600'>Course Resource</h5>
                                <ul style={{ listStyleType: 'none', padding: '10px', paddingLeft: '0px' }}>
                                    {courseDetail.refDoc.map((document, index) => {
                                        const url = document?.refDetails?.documentUrl;
                                        const title = document?.refDetails?.title;
                                        const fileName = document?.refDetails?.title ? document.refDetails.title : 'document';
                                        if (!url || !title) return null;
                                        return <li key={index} style={{ marginBottom: '1rem' }}>
                                            <a className='course-Document' title='Download Course Resource' onClick={() => { downloadFile(url, fileName) }}><DocumentIcon style={{ marginRight: '7px' }} />{title}</a>
                                        </li>
                                    }
                                    )}
                                </ul>
                            </Col>
                        ) : (
                            <Col xs={12} className='p-2 '>
                                <h5 className='fw-600'>Course Resource</h5>
                                <span className='tex-center'>No documents available.</span>
                            </Col>
                        )}
                    </Row>
                </Tab>
                {user.selectedRole.includes('viewer') && (
                    <Tab eventKey="review" title=
                        {<><ReviewIcon style={{ display: 'inline-block', position: 'relative', bottom: '2px' }} title="Review" /> Review</>}>
                        <Row>
                            <Rating courseRatingSummary = {courseDetail?.courseRatingSummary}/>
                        </Row>
                    </Tab>
                )}
            </Tabs >
            {popupData.show ?
                <PopupModel
                    size='md'
                    showModal={popupData.show}
                    handleCloseModal={hidePupop}
                    title={popupData.title}
                    type={popupData.type}
                    footerContent={
                        <Button variant="primary" onClick={hidePupop}>OK</Button>
                    }
                >
                    <div style={{ padding: '10px 0', textAlign: 'center' }}>
                        <p>{popupData.selectedItem.msg}</p>
                    </div>
                </PopupModel> : null
            }

        </>
    );
}

export default React.memo(Coursedetail);